import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import QeeArticle from './qeeArticle';
import QeeSlideDialog from './qeeSlideDialog';
import QeeArticleForm from './qeeArticleForm';
import QeeCart from './qeeCart';
import { ObjChangeProvider } from "./qeeObjChangeProvider";
import QeeStepper from './qeeStepper';
import QeeCustomerInfo from './qeeCustomerInfo';
import QeeOrderConfirmation from './qeeOrderConfirmation';
import { useAuth } from "../context/provider";

const useStyles = makeStyles((theme) => ({
    gridShopItem: {
        height: '100%', 
        backgroundColor: 'white',
        borderRadius: '10px',
    },
    parentContainer: {
        margin: '20px', 
    },
}));

const QeeShop = (props) => {
    const classes = useStyles();
    const { gstate, setOpenQeeDialog } = useAuth();
    const [articles, setArticles] = useState([]);
    const [selectedArtId, setSelectedArtId] = useState(null);
    const [selectedKey, setSelectedKey] = useState(null);    
    const [dialogKey, setDialogKey] = useState(0); 
    const [currentStep, setCurrentStep] = useState(0);
    const [stepperInstanceName, setStepperInstanceName] = useState(null);
    const [stepperStepEnd, setStepperStepEnd] = useState(0);	
	const [objStepper, setObjStepper] = useState(null); 

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await axios.get('/api/arts' + (props.filter ? '?' + props.filter : ''));
                setArticles(response.data.entries.results);
            } catch (error) {
                console.error('Error fetching articles:', error);
            }
        };

        fetchArticles();
    }, [props.filter]);

    useEffect(() => {
        if (selectedArtId !== null) {
			setCurrentStep(0); // Skip to article form
			/*
            // Directly go to article form if no stepper instance is specified
            if (stepperInstanceName) {
                setCurrentStep(1); // Show stepper if instance name is available
            } else {
                setCurrentStep(0); // Skip to article form
            }
			*/
            setOpenQeeDialog({ open: true, id: 'dlgArticle' });
            setDialogKey((prevKey) => prevKey + 1);
        }
    }, [selectedArtId, selectedKey, stepperInstanceName]);

    const getSelectedArticleData = () => {
        if (!selectedArtId) {
            return [];
        }
        const selectedArticle = articles.find((article) => article.art_id === selectedArtId);
        return selectedArticle ? [selectedArticle] : [];
    };

    const handleOpenArticleDialog = (artId) => {
        const selectedArticle = articles.find((article) => article.art_id === artId);
		console.log( 'selectedArticle', selectedArticle);
		
		// in order to call a stepper before the ordering, these 2 fields must be specified in the art 
        const instanceName = selectedArticle?.art_stepper_instance_name || null;
        const stepEnd = selectedArticle?.art_stepper_step_submit_end || 0;	
        setStepperInstanceName(instanceName);
		setStepperStepEnd(stepEnd);
		
        setSelectedKey((prevKey) => prevKey + 1); 
        setSelectedArtId(artId);        
    };

    const handleOnCartNow = () => {
        setDialogKey((prevKey) => prevKey + 1); 
        setCurrentStep((prevStep) => prevStep + 1); 
    };    

    const handleOnCustomerInfo = () => {
        setDialogKey((prevKey) => prevKey + 1); 
        setCurrentStep((prevStep) => prevStep + 1); 
    };        
    
    const handleOnOrderNow = async (billingDetails) => {
        try {
            var usr = JSON.parse(sessionStorage.getItem('usr'));
            if (usr) {
                const facId = gstate.objEdit.id;
				let ordData = { billingDetails };
				if (objStepper) {
					// Create a new object with only the desired properties
					const fm = objStepper.form || ''; // Get the value of the 'form' field or an empty string if it doesn't exist

					// Create a new object with only the desired properties
					const filteredObjStepper = Object.keys(objStepper).reduce((acc, key) => {
						if( key === 'form' || 
							key.startsWith( fm+'_') ||    // more general approach for fileds like lea_*
							key.startsWith( 'org_')) {
							acc[key] = objStepper[key];
						}
						return acc;
					}, {});

					// Merge the filtered objStepper into ordData
					ordData = { ...ordData, leadDetails: filteredObjStepper };
					
					setObjStepper( null);
				}
                const response = await axios.post(`/api/ord/${usr.usrId}/${selectedArtId}?facId=${facId}`, ordData);

                setDialogKey((prevKey) => prevKey + 1); 
                setCurrentStep((prevStep) => prevStep + 1);
            } else {
                console.error('No user data!');
                return { err: 'No user data!' };
            }
        } catch (error) {
            console.error('Error placing order:', error);
        }
    };

    const handleOnOrderDone = () => {
        setCurrentStep(0); 
        setOpenQeeDialog({ open: false, id: 'dlgArticle' });        
    };            
    
	const renderFormComponent = () => {
		var usr = JSON.parse(sessionStorage.getItem('usr'));
		switch (currentStep) {
			case 0:
				return (
					<div style={{ paddingTop: 50 }}>
						<QeeArticleForm artId={selectedArtId} onCartNow={handleOnCartNow} />
					</div>
				);
			case 1:
				// Check if the stepperInstanceName is defined
				if (stepperInstanceName) {
					return (
						<ObjChangeProvider>
							<QeeStepper 
								instanceName={stepperInstanceName} 
								parentWindowClass=".MuiDialog-paper"
								objChange={gstate.objEdit}
								wizReadyFieldName="fac_newbuild_wiz_ready"
								fctSubmitEnd={(objStepper) => {
									console.log( '>>> OBJ CHANGE STEPPER SUBMIT', objStepper);
									setObjStepper( objStepper);
									setCurrentStep(2)   // Move to the next step after stepper is done
								}} 
								stepSubmitEnd={stepperStepEnd}
							/>          
						</ObjChangeProvider>
					);
				} else {
					// If no stepper, go directly to the cart
					setCurrentStep(2);
					return null; // Returning null will allow the next step to render in the sequence
				}
			case 2:
				return (
					<div style={{ paddingTop: 50 }}>
						<QeeCart cartItems={getSelectedArticleData()} onCustomerInfo={handleOnCustomerInfo} />
					</div>
				);
			case 3:
				return (
					<div style={{ paddingTop: 50 }}>
						<QeeCustomerInfo usr={usr} onOrderNow={handleOnOrderNow} />
					</div>
				);           
			case 4:
				return (
					<div style={{ paddingTop: 50 }}>
						<QeeOrderConfirmation artId={selectedArtId} onOrderDone={handleOnOrderDone} />
					</div>
				);
			default:
				return null;
		}
	};

    return (
        <div className={classes.parentContainer}>
            <Grid container spacing={0}>
                {articles.map((article) => (
                    <Grid key={article.art_id} item xs={12} md={4} lg={3} className={classes.gridShopItem} style={{padding:10}}>
                        <QeeArticle 
                            artId={article.art_id} 
                            onOpenDialog={handleOpenArticleDialog} 
                        />
                    </Grid>
                ))}
            </Grid>

            <QeeSlideDialog
                key={dialogKey}
                id="dlgArticle"
                title="Artikel bestellen"
                onClose={() => setOpenQeeDialog({ open: false, id: 'dlgArticle' })}
                formComponent={renderFormComponent()}
                hideDialogActions={true}
                submitDisabled={true}
            />
        </div>
    );
};

export default QeeShop;
